import { __extends } from "tslib";
import { MethodBase, _Shader_MethodBase } from './MethodBase';
/**
 * EffectColorMatrixMethod provides a shading method that changes the colour of a material analogous to a ColorMatrixFilter.
 */
var EffectColorMatrixMethod = /** @class */ (function (_super) {
    __extends(EffectColorMatrixMethod, _super);
    /**
     * Creates a new EffectColorTransformMethod.
     *
     * @param matrix An array of 20 items for 4 x 5 color transform.
     */
    function EffectColorMatrixMethod(matrix) {
        var _this = _super.call(this) || this;
        if (matrix.length != 20)
            throw new Error('Matrix length must be 20!');
        _this._matrix = matrix;
        return _this;
    }
    Object.defineProperty(EffectColorMatrixMethod.prototype, "assetType", {
        /**
         * @inheritDoc
         */
        get: function () {
            return EffectColorMatrixMethod.assetType;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EffectColorMatrixMethod.prototype, "matrix", {
        /**
         * The 4 x 5 matrix to transform the color of the material.
         */
        get: function () {
            return this._matrix;
        },
        set: function (value) {
            if (value.length != 20)
                throw new Error('Matrix length must be 20!');
            this._matrix = value;
            this.invalidate();
        },
        enumerable: false,
        configurable: true
    });
    EffectColorMatrixMethod.assetType = '[asset EffectColorMatrixMethod]';
    return EffectColorMatrixMethod;
}(MethodBase));
export { EffectColorMatrixMethod };
import { ShaderBase } from '@awayjs/renderer';
/**
 * _Shader_EffectColorMatrixMethod provides a shading method that changes the colour of a material analogous to a ColorMatrixFilter.
 */
var _Shader_EffectColorMatrixMethod = /** @class */ (function (_super) {
    __extends(_Shader_EffectColorMatrixMethod, _super);
    function _Shader_EffectColorMatrixMethod() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Creates a new _Shader_EffectColorMatrixMethod
     *
     * @param method
     * @param shader
     */
    _Shader_EffectColorMatrixMethod.prototype.init = function (method, shader) {
        _super.prototype.init.call(this, method, shader);
        this._method = method;
        this._shader = shader;
    };
    /**
     * @inheritDoc
     */
    _Shader_EffectColorMatrixMethod.prototype._getFragmentCode = function (targetReg, registerCache, sharedRegisters) {
        var code = '';
        var colorMultReg = registerCache.getFreeFragmentConstant();
        registerCache.getFreeFragmentConstant();
        registerCache.getFreeFragmentConstant();
        registerCache.getFreeFragmentConstant();
        var colorOffsetReg = registerCache.getFreeFragmentConstant();
        this._colorMatrixIndex = colorMultReg.index * 4;
        var temp = registerCache.getFreeFragmentVectorTemp();
        code += 'm44 ' + temp + ', ' + targetReg + ', ' + colorMultReg + '\n' +
            'add ' + targetReg + ', ' + temp + ', ' + colorOffsetReg + '\n';
        return code;
    };
    /**
     * @inheritDoc
     */
    _Shader_EffectColorMatrixMethod.prototype._activate = function () {
        if (this._invalid) {
            var matrix = this._method.matrix;
            var index = this._colorMatrixIndex;
            var data = this._shader.fragmentConstantData;
            // r
            data[index] = matrix[0];
            data[index + 1] = matrix[1];
            data[index + 2] = matrix[2];
            data[index + 3] = matrix[3];
            // g
            data[index + 4] = matrix[5];
            data[index + 5] = matrix[6];
            data[index + 6] = matrix[7];
            data[index + 7] = matrix[8];
            // b
            data[index + 8] = matrix[10];
            data[index + 9] = matrix[11];
            data[index + 10] = matrix[12];
            data[index + 11] = matrix[13];
            // a
            data[index + 12] = matrix[15];
            data[index + 13] = matrix[16];
            data[index + 14] = matrix[17];
            data[index + 15] = matrix[18];
            // rgba offset
            data[index + 16] = matrix[4];
            data[index + 17] = matrix[9];
            data[index + 18] = matrix[14];
            data[index + 19] = matrix[19];
        }
    };
    return _Shader_EffectColorMatrixMethod;
}(_Shader_MethodBase));
export { _Shader_EffectColorMatrixMethod };
ShaderBase.registerAbstraction(_Shader_EffectColorMatrixMethod, EffectColorMatrixMethod);
